import { useLocation } from 'react-router-dom';

export function useIsCustomerAssistantEmbedMode() {
	const location = useLocation();
	return new URLSearchParams(location.search).get('mode') === 'embed';
}
